import React, { useEffect } from 'react'
import { useAtom } from 'jotai'
import { useQuery } from '@tanstack/react-query'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { ResidentUserType } from '../../../state/stores/units'
import { RegisterMemberBadgeCardBase } from './RegisterMemberBadgeCardBase'
import { RequestsModal } from './RequestsModal'
import { useModal } from '../../../hooks/useModal'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import {
  SocietyNavigationState,
  societyNavigationStateAtom,
} from '../../../views/society/atom'
import { requestQueries } from '../../../api/requests'
import { requestsForSociety } from '../../../state/stores/requests'

interface RegisterMemberRequestCardProps {
  residentUserType: ResidentUserType
}

export const RegisterMemberRequestCard = ({
  residentUserType,
}: RegisterMemberRequestCardProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const [societyNavigationState, setSocietyNavigationState] = useAtom(
    societyNavigationStateAtom
  )
  const { society } = useCurrentSociety()
  const { show: showModal, open: openModal, close: closeModal } = useModal()

  const { data: requestsData } = useQuery(
    requestQueries.getRequestsPerSociety(society?._id)
  )
  const requests = requestsForSociety(requestsData, residentUserType)

  useEffect(() => {
    if (societyNavigationState === SocietyNavigationState.SocietyRequests) {
      openModal()
    }
  }, [openModal, societyNavigationState])

  const onClose = (): void => {
    setSocietyNavigationState(SocietyNavigationState.None)
    closeModal()
  }

  if (requests.length === 0) {
    return null
  }

  return (
    <RequestsModal show={showModal} close={onClose} requests={requests}>
      <RegisterMemberBadgeCardBase
        onClick={openModal}
        count={requests.length}
        label={translate('registerRequest.modal.title')}
      />
    </RequestsModal>
  )
}
